// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
'use strict'
import 'babel-polyfill'
import '@fortawesome/fontawesome-free/css/all.css' // Ensure you are using css-loader
import 'pretty-checkbox/src/pretty-checkbox.scss'
import 'vuetify/dist/vuetify.min.css'
import 'vuetify/src/stylus/app.styl'


//import 'vuetify/src/stylus/main' // Ensure you are using stylus-loader

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import Bootstrap from 'bootstrap'
import App from './App'
//import Sortable from 'vue-sortable'
import router from './router'
import Vuetify from 'vuetify'
import PrettyRadio from 'pretty-checkbox-vue/radio'
import PrettyCheck from 'pretty-checkbox-vue/check'

import { sync } from 'vuex-router-sync'
import store from '@/store/store'
import Panel from '@/components/globals/Panel'
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'
import { Layout } from 'bootstrap-vue/es/components'
import zhHans from 'vuetify/es5/locale/zh-Hans'
import tr from 'vuetify/es5/locale/tr'
import en from 'vuetify/es5/locale/en'
import de from 'vuetify/es5/locale/de'
import ar from 'vuetify/es5/locale/ar'
import { vueHtmlToPaperOptions } from '@/components/globals/consts'
import VueHtmlToPaper from 'vue-html-to-paper';
import {capitalizeFirstLetter } from '@/components/globals/consts'
import VueHtml2Canvas from 'vue-html2canvas'

Vue.config.productionTip = false
Vue.use(Vuetify, 
	{
		iconfont: 'fa',
		lang: {
			locales: {tr, en, de, ar, zhHans},
			current: 'zhHans'
		}
	}
)
Vue.use(VueHtml2Canvas)
Vue.use(VueHtmlToPaper, vueHtmlToPaperOptions)
Vue.use(BootstrapVue)
Vue.use(Layout)
Vue.component('p-check', PrettyCheck)
Vue.component('p-radio', PrettyRadio)
Vue.component('panel', Panel)
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.filter('capitalize', function (value) {
	if (!value) return ''
	value = value.toString()
	return value.charAt(0).toUpperCase() + value.slice(1)
  })

  Vue.filter('fixName', function(origName) {
	if (origName) {
		let newName = origName.split('+').map((a) => capitalizeFirstLetter(a)).join(' ')
		let newName2 = origName.split(' ').map((a) => capitalizeFirstLetter(a)).join(' ')

		if (newName) {
			return newName
		} else if (newName2) {
			return newName2
		}	else {
			return origName
		}
	} else return ''
})

const EventBus = new Vue()
export default EventBus

sync(store, router)

var vm = new Vue({
	el: '#app',
	router,
	store,
	components: { App },
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js